module.exports = __webpack_public_path__ + "img/10_57.7776afa8.png";